import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M60 60Q50 36 80 36q20-8 40 0 30 0 20 24 28 10 20 40 10 30-20 38 10 24-20 24-20 8-40 0-30 0-20-24-30-8-20-38-8-30 20-40" }, null, -1),
    _createElementVNode("path", {
      stroke: "var(--mc-avatar)",
      "stroke-width": "5",
      d: "M100 40v120"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-width": "4",
      d: "M70 70q10 10 0 25 10 10 0 25 10 15 0 30M130 70q-10 10 0 25-10 10 0 25-10 15 0 30"
    }, null, -1)
  ]))]))
}
export default { render: render }